import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ShopError, api, type ContentPage as Page } from '../api';
import { usePageMeta } from '../seo';

/**
 * Informační stránka (O nás, Obchodní podmínky, GDPR, Kontakt…).
 *
 * Obsah se vykresluje jako odstavce TEXTU – nikdy jako HTML, žádné
 * `dangerouslySetInnerHTML`. Prázdný řádek dělí odstavce, jednoduché
 * zalomení drží `white-space: pre-line`.
 */
export function ContentPage() {
  const { slug = '' } = useParams();
  const [page, setPage] = useState<Page | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    api
      .getPage(slug)
      .then((result) => {
        setPage(result.page);
        setError(null);
      })
      .catch((caught: unknown) => {
        setError(caught instanceof ShopError ? caught.message : 'Načtení se nezdařilo.');
      })
      .finally(() => setLoading(false));
  }, [slug]);

  usePageMeta(
    page === null
      ? null
      : { title: `${page.title} | Super Krmivo`, description: page.body.replace(/\s+/g, ' ').slice(0, 160) },
  );

  if (loading) return <p className="muted">Načítám…</p>;
  if (page === null) {
    return (
      <>
        <h1>Stránka nenalezena</h1>
        <p className="muted">{error ?? 'Tuhle stránku se nepodařilo najít.'}</p>
        <Link className="link" to="/">
          Zpět do obchodu
        </Link>
      </>
    );
  }

  const paragraphs = page.body.split(/\n{2,}/).filter((part) => part.trim() !== '');

  return (
    <article className="content-page">
      <h1>{page.title}</h1>
      {paragraphs.length === 0 ? (
        <p className="muted">Zatím bez obsahu.</p>
      ) : (
        paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)
      )}
    </article>
  );
}
